import { fbDB } from "../config/firebase";
import {
  CLASS_CODE_ADD,
  CLASS_CODE_REMOVE,
  CLASS_CODES_WATCH_ON,
  CLASS_CODES_WATCH_OFF
} from "./types";

export const classCodeAdd = codes => async dispatch => {
  fbDB
    .ref("/classCodes")
    .set(codes)
    .then(() => {
      console.log("classCodes add complete");
      return dispatch({
        type: CLASS_CODE_ADD,
        payload: null
      });
    })
    .catch(err => {
      console.log(err);
    });
};

export const classCodeRemove = code => async dispatch => {
  fbDB
    .ref("/classCodes")
    .transaction(data => data.filter(data => data !== code))
    .then(() => {
      console.log("classCodes remove complete");
      return dispatch({
        type: CLASS_CODE_REMOVE,
        payload: null
      });
    })
    .catch(err => {
      console.log(err);
    });
};

export const classCodesWatchOn = () => async dispatch => {
  fbDB.ref("/classCodes").on("value", snapshot =>
    dispatch({
      type: CLASS_CODES_WATCH_ON,
      payload: snapshot.val()
    })
  );
};

export const classCodesWatchOff = () => async dispatch => {
  fbDB.ref("/classCodes").off();
  return dispatch({
    type: CLASS_CODES_WATCH_OFF,
    payload: null
  });
};
